import React, { Component } from 'react';
import cx from 'classnames';
import './style.scss';

class FileDropzone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadMouseOver: false,
    };
  }

  render() {
    return (
      <div
        className="upload"
        onDragEnter={() => this.setState({ uploadMouseOver: true })}
        onDragLeave={() => this.setState({ uploadMouseOver: false })}
        onDrop={(ev) => {
          ev.preventDefault();

          if (ev.dataTransfer.items) {
            // Use DataTransferItemList
            for (let i = 0; i < ev.dataTransfer.items.length; i++) {
              if (ev.dataTransfer.items[i].kind === 'file') {
                // const file = ev.dataTransfer.items[i].getAsFile();
                // console.log(`... file[${i}].name = ${file.name}`);
              }
            }
          } else {
            // Use DataTransfer
            for (let i = 0; i < ev.dataTransfer.files.length; i++) {
              // console.log(`... file[${i}].name = ${ev.dataTransfer.files[i].name}`);
            }
          }
        }}
      >
        <div className={cx('hovered', { mouseOver: this.state.uploadMouseOver })} />
        {this.props.children}
      </div>
    );
  }
}

export { FileDropzone };



// WEBPACK FOOTER //
// ./src/view/common/FileDropzone/index.jsx